import React, { useEffect } from "react";
import "./ProjectraLO.css";

// BYT TILL DINA RIKTIGA BILDER:
import HeroMockup from "../../assets/projectratyp.png";
import RowImg1 from "../../assets/logga.png";
import RowImg2 from "../../assets/logga2.png";
import Visual1 from "../../assets/logga5.png";
import Visual2 from "../../assets/logga4.png";
import Visual3 from "../../assets/loggomain.svg";

function useProjectraLoScrollReveal() {
  useEffect(() => {
    const root = document.querySelector(".projectra-lo-page");
    if (!root) return;

    const elements = root.querySelectorAll(".projectra-lo-reveal");
    if (!elements.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("projectra-lo-is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
}

export default function ProjectraLO() {
  useProjectraLoScrollReveal();

  return (
    <main className="projectra-lo-page">
      {/* Valfri dekor i bakgrunden */}
      {/* <div className="projectra-lo-bg" /> */}

      {/* ================= HERO ================= */}
      <section className="projectra-lo-hero projectra-lo-reveal">
        <div className="projectra-lo-hero-copy">
          <p className="projectra-lo-hero-kicker">Brand identity · Logo design</p>

          <h1 className="projectra-lo-hero-title">
            Projectra Logo
            <span className="projectra-lo-hero-title-accent"> visual identity</span>
          </h1>

          <p className="projectra-lo-hero-body">
            This project focused on creating a logo concept and a visual identity direction
            for Projectra. The goal was to design something modern, clear and flexible enough
            to work across different platforms.
            <br /><br />
            The result includes logo variations, typography direction and usage examples to
            keep the identity consistent.
          </p>

          <div className="projectra-lo-hero-tags">
            <span>Branding</span>
            <span>Logo Design</span>
            <span>Visual Identity</span>
          </div>

          {/* Valfri knapp */}
          {/* <button
            className="projectra-lo-primary-cta"
            type="button"
            onClick={() => window.open("https://...", "_blank")}
          >
            View the case
          </button> */}
        </div>

        <div className="projectra-lo-hero-image">
          
            <img src={HeroMockup} alt="Projectra logo mockup" />

        </div>
      </section>

      {/* ================= DESIGN SOLUTION ================= */}
      <section className="projectra-lo-section projectra-lo-reveal">
        <h2 className="projectra-lo-section-title">Design solution</h2>
        <p className="projectra-lo-large-text">
          The identity is built around a clean wordmark and a simplified symbol that can be used
          independently for icons and social media. The system prioritizes readability, scalability
          and recognizability across digital and print.
        </p>
      </section>

      {/* ================= JOURNEY ================= */}
      <section className="projectra-lo-section projectra-lo-reveal">
        <h2 className="projectra-lo-section-title">The Journey</h2>

        <div className="projectra-lo-columns-3">
          <div className="projectra-lo-card">
            <h3>Exploration</h3>
            <p>
              Started with sketches and moodboards to define tone, shapes and typography that matched
              the brand direction.
            </p>
          </div>

          <div className="projectra-lo-card">
            <h3>Refinement</h3>
            <p>
              Selected concepts were refined through typography tests, proportion adjustments and
              color exploration to find the strongest direction.
            </p>
          </div>

          <div className="projectra-lo-card">
            <h3>Delivery</h3>
            <p>
              Exported final logo variations and created simple guidelines for spacing, color usage
              and consistency across platforms.
            </p>
          </div>
        </div>
      </section>

      {/* ================= MOCKUPS (2 bilder) ================= */}
      <section className="projectra-lo-image-row projectra-lo-reveal">
        <img src={RowImg1} alt="Projectra logo application mockup 1" />
        <img src={RowImg2} alt="Projectra logo application mockup 2" />
      </section>

      {/* ================= VISUALS ================= */}
      <section className="projectra-lo-section projectra-lo-reveal">
        <h2 className="projectra-lo-section-title">Visuals</h2>
        <p className="projectra-lo-large-text">
          A minimal visual style with a strong typographic hierarchy and a balanced palette. The identity
          is designed to feel professional yet approachable and easy to apply in different contexts.
        </p>
      </section>

      <section className="projectra-lo-image-row-3 projectra-lo-reveal">
        <img src={Visual1} alt="Logo variation 1" />
        <img src={Visual2} alt="Logo variation 2" />
        <img src={Visual3} alt="Logo variation 3" />
      </section>
    </main>
  );
}

